
function shadeColor2(color, percent) {
  var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
  return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
}

function blendColors(c0, c1, p) {
  var f=parseInt(c0.slice(1),16),t=parseInt(c1.slice(1),16),R1=f>>16,G1=f>>8&0x00FF,B1=f&0x0000FF,R2=t>>16,G2=t>>8&0x00FF,B2=t&0x0000FF;
  return "#"+(0x1000000+(Math.round((R2-R1)*p)+R1)*0x10000+(Math.round((G2-G1)*p)+G1)*0x100+(Math.round((B2-B1)*p)+B1)).toString(16).slice(1);
}



export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


// http://www.w3.org/TR/AERT#color-contrast
function getContrastColor(hex) {
  var rgb = hexToRgb(hex);
  console.log(rgb);
  var o = Math.round(((parseInt(rgb.r) * 299) +
    (parseInt(rgb.g) * 587) +
    (parseInt(rgb.b) * 114)) / 1000);
  console.log(o);
  return (o > 125) ? 'black' : 'white';
}

function getColors(color) {
  return {
      color: color,
      contrastColor: getContrastColor(color),
      hoverColor: shadeColor2(color, 0.1),
      hoverContrastColor: getContrastColor(shadeColor2(color, 0.1))
  }
}

function getColorsShades(color) {
  return {
    main: getColors(color),
    dark: getColors(shadeColor2(color, -0.3)),
    light: getColors(shadeColor2(color, 0.8)),
  }
}


function getThemeColors() {
    // Not yet supported on consumer, and only EF who use it:
    const colors = {
        primary: getColorsShades('#000000'),
        seconary: getColorsShades('#000000')
    };
    console.log('Colors', colors);
    return colors;
  //return window.NTLF_CONFIG.portal.theme.colors;
}

export {
    getThemeColors,
    getContrastColor,
    shadeColor2,
    getColorsShades
}